import { render, staticRenderFns } from "./FormAccessRequestDatasourceDS.vue?vue&type=template&id=c162efc2&lang=pug"
import script from "./FormAccessRequestDatasourceDS.vue?vue&type=script&lang=js"
export * from "./FormAccessRequestDatasourceDS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c162efc2')) {
      api.createRecord('c162efc2', component.options)
    } else {
      api.reload('c162efc2', component.options)
    }
    module.hot.accept("./FormAccessRequestDatasourceDS.vue?vue&type=template&id=c162efc2&lang=pug", function () {
      api.rerender('c162efc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/components/FormAccessRequestDatasourceDS.vue"
export default component.exports